import { withMetadata } from '../metadata'
import { validatePhoneNumberLength as _validatePhoneNumberLength } from '../../core/index'

export function validatePhoneNumberLength() {
	return withMetadata(_validatePhoneNumberLength, arguments)
}


//////////////////
// WEBPACK FOOTER
// ./~/libphonenumber-js/min/exports/validatePhoneNumberLength.js
// module id = E+D7
// module chunks = 0 1